var _path, _path2, _path3, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    fill: "#524c4c",
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,3v8H11V0H3A3,3,0,0,0,0,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,21a3,3,0,0,0,3,3h8V13H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13,13V24h8a3,3,0,0,0,3-3V13Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17 11 19 11 19 7 23 7 23 5 19 5 19 1 17 1 17 5 13 5 13 7 17 7 17 11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLogo);
export default __webpack_public_path__ + "static/media/addLogo.a9096f8ce2ed0bfa4752cc0e632fa717.svg";
export { ForwardRef as ReactComponent };